import { customerServiceOne } from '../../../services/service-factory';

export default {
  data: function() {
    return {
      customerService: undefined
    };
  },
  created: function() {
    this.customerService = customerServiceOne;
  }
};
